import { FleekError } from './FleekError';

type EnsNameContentHashUndefinedErrorOptions = {
  ensRecord: Record<'name', string>;
};

export class EnsNameContentHashUndefinedError extends FleekError<EnsNameContentHashUndefinedErrorOptions> {
  public name = 'EnsNameContentHashUndefinedError';

  toString = () => {
    return `The content hash for ENS record name "${this.data.ensRecord.name}" is undefined.`;
  };
}
